import { Button, notification, Form } from "antd";
import config from "Configurations";
import firebase from "firebase";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ReCAPTCHA from "react-google-recaptcha";
import { USER } from "util/constants";
import styles from "./styles.module.scss";

function AppSumo() {
  const { t } = useTranslation();
  const [checkRecaptcha, setCheckRecaptcha] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  if (firebase.auth().currentUser) {
    window.location.href = '/';
  }

  useEffect(() => {
    const el = document.getElementById("header_to_menu");
    if (el?.style) {
      el.style.display = "none";
    }
    return () => {
      if (el?.style) {
        el.style.display = "";
      }
    };
  }, []);

  const signUpUser = async (values) => {
    if (
      !checkRecaptcha &&
      document.location.origin !== "http://localhost:3000"
    ) {
      notification.error({
        message: t("landing_appsumo.recaptcha_title", "Google Recaptcha"),
        description: t("signup_page.recaptcha_required", "You must verify with google recaptcha"),
      });
      return;
    }
    setLoading(true);

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({
        code: values.appsumo,
        user_email: values.email,
      }),
    };

    await fetch(config.BASE_URL + "users/appsumo/check_coupon", requestOptions)
      .then((response) => response.text())
      .then(async (result2) => {
        const result = JSON.parse(result2);
        if (result.error) {
          notification.error({
            message: t("landing_appsumo.error", "Error"),
            description: result.error,
          });
        } else {
          let user = {
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            type: USER,
            emailVerified: true,
          };

          firebase
            .auth()
            .createUserWithEmailAndPassword(values.email, values.password)
            .then(async (response) => {
              const res = response.user.toJSON();
              registerUID(res.uid, response.user, user, values.appsumo);
            })
            .catch(function (error) {
              var errorMessage = error.message;
              notification.error({
                message: t("landing_appsumo.error", "Error"),
                description: errorMessage,
              });
              setLoading(false);
            });
        }
        setLoading(false);
      })
      .catch((error) => {
        notification.error({
          message: t("landing_appsumo.error", "Error"),
          description: error.message,
        });
        setLoading(false);
      });
  };

  const registerUID = async (uid, authUser, objUser, appSumoCode) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({
        user_id: uid,
        code: appSumoCode,
      }),
    };

    await fetch(
      config.BASE_URL + "subscriptions/appsumo/create",
      requestOptions
    )
      .then((response) => response.text())
      .then(async (result2) => {
        const result = JSON.parse(result2);
        if (result.error) {
          authUser.delete();
          notification.error({
            message: t("landing_appsumo.error", "Error"),
            description: result.error,
          });
        } else {
          await firebase
            .database()
            .ref(`/users/${uid}`)
            .set({ ...objUser, plan: result.packageId });
          document.location.href = document.location.origin;
        }
        setLoading(false);
      })
      .catch((error) => {
        authUser.delete();
        notification.error({
          message: t("landing_appsumo.error", "Error"),
          description: error.message,
        });
        setLoading(false);
      });
  };

  const verifyRecaptcha = (token) => {
    setCheckRecaptcha(true);
  };

  return (
    <div className={styles.container}>
      <div className={styles.carouselContent}>
        <div style={{ width: "100%" }}>
          <img style={{ width: "100%" }} src="/assets/appSumo.png" alt="" />
        </div>

        <div className={styles.title}>
          <h1>{t("landing_appsumo.welcome_title", "Hey Sumo-ling, welcome to Pivony!")} </h1>
          <h2>{t("landing_appsumo.welcome_subtitle", "Welcome to Pivony! Do you have your AppSumo code? If so, please fill the form and click \"Sign Up\" to start adding value to you business with Pivony.")} </h2>
        </div>

        <div className={styles.form}>
          <Form form={form} name="mainDetails" onFinish={signUpUser}>
            <Form.Item
              name="appsumo"
              label={t("landing_appsumo.appsumo_code", "AppSumo Code")}
              rules={[
                {
                  required: true,
                  message: t("landing_appsumo.appsumo_code_required", "AppSumo code is required"),
                },
              ]}
            >
              <input className={styles.inputForm} />
            </Form.Item>
            <Form.Item
              name="firstName"
              label={t("landing_appsumo.first_name", "First name")}
              rules={[
                {
                  required: true,
                  message: t("signup_page.first_name_required", "First name is required"),
                },
              ]}
            >
              <input placeholder="John" className={styles.inputForm} />
            </Form.Item>
            <Form.Item
              name="lastName"
              label={t("landing_appsumo.last_name", "Last name")}
              rules={[
                {
                  required: true,
                  message: t("signup_page.last_name_required", "Last name is required"),
                },
              ]}
            >
              <input placeholder="Doe" className={styles.inputForm} />
            </Form.Item>
            <Form.Item
              name="email"
              label={t("landing_appsumo.appsumo_email", "AppSumo Email")}
              rules={[
                {
                  required: true,
                  message: t("landing_appsumo.appsumo_email_required", "AppSumo e-mail address is required"),
                },
              ]}
            >
              <input
                type="email"
                placeholder="john.doe@gmail.com"
                className={styles.inputForm}
              />
            </Form.Item>
            <Form.Item
              name="password"
              label={t("landing_appsumo.password", "Password")}
              rules={[
                {
                  required: true,
                  message: t("signup_page.password_required", "Password is required"),
                },
              ]}
            >
              <input type="password" className={styles.inputForm} />
            </Form.Item>
            <Form.Item style={{ textAlign: "center" }}>
              <div className={styles.recaptcha}>
                <ReCAPTCHA
                  style={{ display: "inline-block" }}
                  onChange={verifyRecaptcha}
                  sitekey={config.RECAPTCHA_SITE_PUBLIC_KEY}
                />
              </div>
              <Button
                loading={loading}
                className={styles.btn}
                type="primary"
                htmlType="submit"
                style={{ height: "auto" }}
              >
                {t("landing_appsumo.sign_up", "Sign up")}
              </Button>
            </Form.Item>
            <Form.Item style={{ textAlign: "center" }}>
              <p className={styles.terms}>
                {t("landing_appsumo.terms_agree", "By clicking the button above, you agree to our")} <br />
                <a href="https://pivony.com/terms/" target="_blank" rel="noopener noreferrer">
                  {t("landing_appsumo.terms_of_service", "Terms of Service")}
                </a>{" "}
                {t("landing_appsumo.and", "and")}{" "}
                <a href="https://pivony.com/privacy/" target="_blank" rel="noopener noreferrer">
                  {t("landing_appsumo.privacy_policy", "Privacy Policy")}
                </a>
              </p>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default AppSumo;
